import { ImmutableStore } from 'fluxible-immutable-utils';
import Actions from '../constants/Actions';
import FormState from '../constants/FormState';
import Immutable from 'immutable';
import emptyRule from '../apps/Products/util/emptyRule';
import isEmpty from 'lodash.isempty';

const defaultState = {
  sidebarActive: true,
  licensedCategories: [
    'consumer-checking',
    'consumer-checking-addOns',
    'consumer-savings',
    /*'consumer-savings-addOns',*/
    'consumer-lending',
    'business-checking',
    'business-checking-addOns',
    'business-savings',
    'business-lending',
    'business-treasury'
  ],
  productFormStatus: FormState.INITIAL,
  products: [],
  associatedProducts: [],
  requiredProducts: [],
  ruleTypes: [],
  costTypes: [],
  locationSearchTerm: ''
};

const newProduct = {
  id: -1,
  active: true,
  name: '',
  description: {
    short: '',
    long: ''
  },
  category: 'unknown',
  keys: [],
  url: '',
  applicationUrl: '',
  rules: [emptyRule()],
  cost: {},
  disclosures: [],
  features: [],
  locations: {},
  priority: 10000
};

class ProductsStore extends ImmutableStore {
  static storeName = 'ProductsStore';

  static handlers = {
    [Actions.SIDEBAR_TOGGLE_CLICKED]: 'handleSidebarToggle',
    [Actions.EDIT_PRODUCT_CLICKED]: 'handleEditProduct',
    [Actions.EDIT_PRODUCT_COMPLETE]: 'doneEditingProduct',
    [Actions.PRODUCTS_LOADED]: 'receiveProducts',
    [Actions.ASSOCIATED_PRODUCTS_LOADED]: 'receiveAssociatedProducts',
    [Actions.REQUIRED_PRODUCTS_LOADED]: 'receiveRequiredProducts',
    [Actions.PRODUCT_RULE_TYPES_LOADED]: 'receiveRuleTypes',
    [Actions.PRODUCT_COST_TYPES_LOADED]: 'receiveCostTypes',
    [Actions.PRODUCT_LOCATION_SEARCH_UPDATED]: 'updateLocationSearchTerm'
  };

  constructor(dispatcher) {
    super(dispatcher);
    this.setState(defaultState);
  }

  isSidebarActive() {
    return this.get('sidebarActive');
  }

  getProductCategories() {
    return this.get('licensedCategories').toJS();
  }

  getProducts() {
    return this.get('products').toJS();
  }

  getAssociatedProducts() {
    return this.get('associatedProducts').toJS();
  }

  getRequiredProducts() {
    return this.get('requiredProducts').toJS();
  }

  getActiveProduct() {
    const product = this.get('activeProduct');
    return product ? product.toJS() : null;
  }

  getStatus() {
    return this.get('productFormStatus');
  }

  handleSidebarToggle() {
    this.mergeState({
      sidebarActive: !this.isSidebarActive()
    });
  }

  receiveProducts({products}) {
    this.mergeState({
      products: Immutable.fromJS(products).sortBy(p => p.get('priority'))
    });
  }

  receiveAssociatedProducts({products}) {
    this.mergeState({
      associatedProducts: Immutable.fromJS(products).sortBy(p => p.get('priority')).filter(p => p.get('active'))
    });
  }

  receiveRequiredProducts(requiredProducts) {
    this.mergeState({
      requiredProducts: Immutable.fromJS(requiredProducts).sortBy(p => `${p.get('category')}-${p.get('name')}`).filter(p => p.get('active'))
    });
  }

  receiveRuleTypes({ruleTypes = [],}) {
    this.mergeState({
      ruleTypes
    });
  }

  receiveCostTypes({costTypes = [],}) {
    this.mergeState({
      costTypes
    });
  }

  getRuleTypes() {
    return this.get('ruleTypes').toJS();
  }

  getCostTypes() {
    return this.get('costTypes').toJS();
  }

  handleEditProduct({product = newProduct, rules: incomingRules, cost: incomingCost}) {
    const rules = (incomingRules && incomingRules.length) ? incomingRules : [emptyRule()];
    const cost = (incomingCost && !isEmpty(incomingCost)) ? incomingCost : {};

    this.mergeState({
      activeProduct: {
        product,
        rules,
        cost
      },
      locationSearchTerm: ''
    });
  }

  doneEditingProduct() {
    this.mergeState({
      activeProduct: null
    });
  }

  getLocationSearchTerm() {
    return this.get('locationSearchTerm');
  }

  updateLocationSearchTerm(searchTerm) {
    console.log('updateLocationSearchTerm', searchTerm);
    this.mergeState({
      locationSearchTerm: searchTerm
    });
  }

  rehydrate(state) {
    super.rehydrate(state);
  }
}

export default ProductsStore;



// WEBPACK FOOTER //
// ./src/stores/ProductsStore.js